module.exports = __webpack_public_path__ + "static/media/css.bf570357.png";